import { createFileRoute } from "@tanstack/react-router";
import { siteConfig } from "@/config";

export const Route = createFileRoute("/about-us")({
  head: () => ({
    meta: [
      { title: `About Us | ${siteConfig.siteName}` },
      {
        name: "description",
        content: `Learn about ${siteConfig.siteName} — our mission, editorial standards, and the people behind our B2B software reviews.`,
      },
      { property: "og:title", content: `About ${siteConfig.siteName}` },
      { property: "og:url", content: `${siteConfig.domain}/about-us` },
    ],
    links: [{ rel: "canonical", href: `${siteConfig.domain}/about-us` }],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <section className="mx-auto max-w-3xl px-4 py-14">
      <h1 className="text-4xl font-bold tracking-tight text-foreground">
        About {siteConfig.siteName}
      </h1>
      <div className="prose-article mt-6">
        <p>
          {siteConfig.siteName} is an independent publication covering the B2B software industry
          for US business decision makers. We write in-depth reviews, comparisons, and buyer's
          guides across CRM, ERP, and SaaS categories — with a focus on real-world usability,
          honest pricing analysis, and the trade-offs that vendors don't put on their websites.
        </p>
        <h2>Our mission</h2>
        <p>
          B2B software is one of the largest — and most opaque — categories of business spending.
          Our mission is to give operators, founders, and IT leaders the signal they need to make
          confident purchasing decisions without wading through vendor marketing copy or paid
          rankings dressed up as reviews.
        </p>
        <h2>Editorial standards</h2>
        <p>
          Every review on {siteConfig.siteName} is based on hands-on testing with real accounts and
          real data. When we compare products, we use the same evaluation rubric across all
          vendors and disclose any material relationships. We never accept payment in exchange for
          positive coverage, and any affiliate relationships are clearly disclosed on the pages
          where they apply.
        </p>
        <h2>How we make money</h2>
        <p>
          Our reporting is supported by display advertising and, on select pages, affiliate
          partnerships with software vendors. These relationships never influence our editorial
          judgment or rankings. Our reviewers are independent from our commercial team.
        </p>
        <h2>Who reads {siteConfig.siteName}</h2>
        <p>
          Our audience is primarily US-based founders, RevOps and IT leaders, and operations
          teams at small and mid-market businesses evaluating new software. We write for people
          who need to make a decision this week — not next quarter.
        </p>
        <h2>Get in touch</h2>
        <p>
          Have feedback, corrections, or a story tip? Email us at{" "}
          <a href={`mailto:${siteConfig.contactEmail}`}>{siteConfig.contactEmail}</a> or visit our{" "}
          <a href="/contact-us">contact page</a>. Our website is{" "}
          <a href={siteConfig.domain}>crmworldguide.com</a>.
        </p>
      </div>
    </section>
  );
}
